import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HeaderFactoryService {
  public static cardsCount: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public static isViewedCards: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}
